/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ビューア用ページモデル(1ページ分)
 * @export
 * @interface ViewerPageModel
 */
export interface ViewerPageModel {
    /**
     * ページ画像URL
     * @type {string}
     * @memberof ViewerPageModel
     */
    imageUrl: string;
    /**
     * スクランブル文字列
     * @type {string}
     * @memberof ViewerPageModel
     */
    scramble: string;
    /**
     * ページ番号(0始まり)
     * @type {number}
     * @memberof ViewerPageModel
     */
    sort: number;
    /**
     * 画像サイズ幅
     * @type {number}
     * @memberof ViewerPageModel
     */
    width: number;
    /**
     * 画像サイズ高さ
     * @type {number}
     * @memberof ViewerPageModel
     */
    height: number;
    /**
     * 有効期限
     * @type {number}
     * @memberof ViewerPageModel
     */
    expiresOn: number;
}

/**
 * Check if a given object implements the ViewerPageModel interface.
 */
export function instanceOfViewerPageModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "imageUrl" in value;
    isInstance = isInstance && "scramble" in value;
    isInstance = isInstance && "sort" in value;
    isInstance = isInstance && "width" in value;
    isInstance = isInstance && "height" in value;
    isInstance = isInstance && "expiresOn" in value;

    return isInstance;
}

export function ViewerPageModelFromJSON(json: any): ViewerPageModel {
    return ViewerPageModelFromJSONTyped(json, false);
}

export function ViewerPageModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViewerPageModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imageUrl': json['imageUrl'],
        'scramble': json['scramble'],
        'sort': json['sort'],
        'width': json['width'],
        'height': json['height'],
        'expiresOn': json['expiresOn'],
    };
}

export function ViewerPageModelToJSON(value?: ViewerPageModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'imageUrl': value.imageUrl,
        'scramble': value.scramble,
        'sort': value.sort,
        'width': value.width,
        'height': value.height,
        'expiresOn': value.expiresOn,
    };
}

